import React from "react";

import { formatDayDate, formatDayMonth, useTranslation } from "utils";

import { StatusLabel } from "components";

const getLabelProps = ({ date, daysLeft, status, t }) => {
  const formattedDate = formatDayDate(date, { ordinal: true });

  const labelProps = {
    dueDate: {
      iconName: "tabler/calendar",
      color: "grey",
      text: t("statusLabel.dueDate", { date: formattedDate }),
    },
    dueDateHighlighted: {
      iconName: "tabler/calendar",
      color: "yellow",
      text: t("statusLabel.dueDate", { date: formattedDate }),
    },
    noDeadline: {
      iconName: "tabler/clipboard-check",
      color: "yellow",
      text: "",
    },
    nextStep: {
      iconName: "tabler/clock",
      color: "grey",
      text: t("statusLabel.nextStep", { date: formattedDate }),
    },
    submitted: {
      iconName: "tabler/circle-check",
      color: "grey",
      text: t("statusLabel.submitted"),
    },
    readyToReview: {
      iconName: "tabler/eye",
      color: "blue",
      text: t("statusLabel.readyToReview"),
    },
    deadlineUpcoming: {
      iconName: "tabler/clock",
      color: "orange",
      text: t("statusLabel.deadlineUpcoming", { days: daysLeft }),
    },
    late: {
      iconName: "tabler/alert-triangle",
      color: "red",
      text: t("statusLabel.late"),
    },
    verificationPending: {
      iconName: "tabler/calendar",
      color: "yellow",
      text: formatDayMonth(date, { longMonth: false, trimDot: true }),
    },
    inVerification: {
      iconName: "tabler/clock",
      color: "grey",
      text: t("statusLabel.inVerification"),
    },
    approved: {
      iconName: "tabler/circle-check",
      color: "green",
      text: t("statusLabel.approved"),
    },
    rejected: {
      iconName: "tabler/circle-x",
      color: "red",
      text: t("statusLabel.rejected"),
    },
    completedTasks: {
      iconName: "tabler/circle-check",
      color: "grey",
      text: t("statusLabel.completedTasks"),
    },
    invoicePending: {
      iconName: "tabler/clock",
      color: "grey",
      text: t("statusLabel.invoicePending"),
    },
    onHold: {
      iconName: "tabler/lock",
      color: "grey",
      text: t("statusLabel.onHold"),
    },
  };

  return labelProps[status];
};

// Date is only relevant for states dueDate, dueDateHighlighted and nextStep
// DaysLeft only for deadlineUpcoming
export const TimelineStatusLabel = ({ status, date = "", daysLeft = 0 }) => {
  const { t } = useTranslation("misc");

  return <StatusLabel {...getLabelProps({ date, daysLeft, status, t })} />;
};
